import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UtilityService } from '../../core/services/utility/utility.service';
import { NgIf } from '@angular/common';
import { VideosLeftNavigationPaneComponent } from './videos-left-navigation-pane/videos-left-navigation-pane.component';
import { RouterOutlet } from '@angular/router';

export interface IMedia {
  title: string;
  src: string;
  type: string;
}

@Component({
    selector: 'app-videos',
    templateUrl: './videos.component.html',
    styleUrls: ['./videos.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, VideosLeftNavigationPaneComponent, RouterOutlet]
})
export class VideosComponent implements OnInit {

  public screenWidth: number;
  
  constructor(private utilityService: UtilityService) {
    this.screenWidth = this.utilityService.getScreenWidth();
   }

  ngOnInit() {
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

}
